@if (!isAuthRoute) {
<!-- App Layout -->
<div class="min-h-screen w-full max-w-screen bg-[#F3F2F7] overflow-x-hidden" id="app-layout">
  <!-- Main Content + Side Content Layout -->
  <div
    class="main-container grid grid-cols-1"
    [class.lg:grid-cols-[1fr_320px]]="!isAuthRoute"
  >
    <!-- Main Content Area -->
    <main class="min-h-screen">
      <div class="p-0 md:p-8 !pt-0 lg:!pr-0">
        <router-outlet></router-outlet>
      </div>
    </main>

    <!-- Side Content -->
    @if (!isAuthRoute) {
    <app-side-content-column></app-side-content-column>
    }
  </div>
  <!-- <app-toast></app-toast> -->
</div>
} @else {
<div class="auth-route h-screen w-full max-w-screen bg-[#F3F2F7]">
  <main class="h-full">
    <router-outlet></router-outlet>
    <!-- <app-toast></app-toast> -->
  </main>
</div>
}
<p-toast [position]="toastPosition" [breakpoints]="toastBreakpoints"></p-toast>